import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendQueryGetMultiPromptRunnerArgs,
  BackendSuggestionRequest,
} from 'src/types/backend';

import { FRAGMENT_SUGGEST_REQUEST } from './schema';

const QUERY = gql`
  query GetMultiPromptRunner($projectId: ID!, $chainId: ID, $csvChainId: ID) {
    getMultiPromptRunner(projectId: $projectId, chainId: $chainId, csvChainId: $csvChainId) {
      ...SuggestionRequest
    }
  }
  ${FRAGMENT_SUGGEST_REQUEST}
`;

type Variables = BackendQueryGetMultiPromptRunnerArgs;
type Result = BackendSuggestionRequest[];

export const getMultiPromptRunner = async (variables: Variables) => {
  const response = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(response.data);
};
